import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OAuthService } from '../shared/services/authorization/oauth.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss']
})
export class CallbackComponent implements OnInit {
  public authFailed = false;

  constructor(private authorizationService: OAuthService, private route: ActivatedRoute, private titleService: Title) { }

  ngOnInit(): void {
    this.titleService.setTitle('Arvest Business Partner Portal: Authenticating');
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.determineAuthStep);
    } else {
      this.determineAuthStep();
    }
  }

  determineAuthStep() {
    this.route.queryParamMap.subscribe(paramMap => {
      const code = paramMap.get('code') || false;
      let currentAuthRequest = localStorage.getItem('appauth_current_authorization_request');

      if (code && currentAuthRequest) {
        // if we have a code in the URL and an PKCE code generated,
        // we need to check for authorization response
        this.authorizationService.checkForAuthorizationResponse();
      } else {
        // if we don't, we need to kick off the authentication process
        this.authorizationService.authorize('/loan-images');
      }
    });

  }

}
